import React from "react";
import { Link } from "react-router-dom";
import {
  ClarkFooterContainer,
  ClarkFooterHeading,
  ClarkFooterImage,
  ClarkFooterText,
  ContactContainer,
  ContactImg,
  ContactLink,
  ContactRow,
  FooterContainer,
  LinksRow,
  LocationText,
  LogoImg,
  LogoRow,
  StyledLink,
} from "./styled";

import Clark100Years from "../../images/Footer/Clark 100 years.png";
import EmailImg from "../../images/Footer/email.svg";
import MapImg from "../../images/Footer/map.svg";
import PhoneImg from "../../images/Footer/phone.svg";

function Footer() {
  return (
    <>
      <ClarkFooterContainer>
        <ClarkFooterHeading>Stali jsme se oficiálním distributorem značky CLARK</ClarkFooterHeading>
        <ClarkFooterText>
          S hrdostí oznamujeme, že naše společnost <b>RPK TECHNIK s.r.o.</b> se stala oficiálním distributorem značky <b>CLARK</b>, jednoho z předních světových výrobců manipulační techniky. Tento
          významný krok nám umožňuje nabídnout našim zákazníkům špičkové produkty, jako jsou vysokozdvižné vozíky, paletové vozíky a další zařízení pro efektivní manipulaci s materiálem. Spojením
          našich odborných servisních služeb a školení s kvalitou a inovacemi značky CLARK zajišťujeme komplexní řešení pro vaše potřeby v oblasti skladové techniky. Prohlédněte si náš certifikát
          autorizovaného distributora níže a neváhejte nás kontaktovat pro více informací o produktech CLARK.
        </ClarkFooterText>
        <ClarkFooterImage src={Clark100Years} alt="Značka Clark je na trhu již 100 let"></ClarkFooterImage>
      </ClarkFooterContainer>
      <FooterContainer>
        <LogoRow>
          <Link to={"/"} style={{ textDecoration: "none" }}>
            <LogoImg src={"/images/ContactForm/originalLogo.svg"} alt="Logo firmy RPK Technik" />
          </Link>
        </LogoRow>

        <LinksRow>
          <Link to={"/objednavka-servisu"} style={{ textDecoration: "none" }}>
            <StyledLink>Objednávka servisu</StyledLink>
          </Link>
          <Link to={"/bazarove-stroje"} style={{ textDecoration: "none" }}>
            <StyledLink>Bazarové stroje</StyledLink>
          </Link>
          <Link to={"/nove-stroje"} style={{ textDecoration: "none" }}>
            <StyledLink>Nové stroje</StyledLink>
          </Link>
          <Link to={"/kariera"} style={{ textDecoration: "none" }}>
            <StyledLink>Kariéra</StyledLink>
          </Link>
          <Link to={"/kontakt"} style={{ textDecoration: "none" }}>
            <StyledLink>Kontakt</StyledLink>
          </Link>
          <a href={"/documents/servisni-podminky.pdf"} target="_blank" rel="noopener noreferrer" style={{ textDecoration: "none" }}>
            <StyledLink>Servisní podmínky</StyledLink>
          </a>
        </LinksRow>

        <ContactRow>
          <ContactContainer>
            <ContactImg src={PhoneImg} alt="Obrázek znázorňující telefon" />
            <ContactLink href="tel:+420 739 235 235">+420 739 235 235</ContactLink>
          </ContactContainer>
          <ContactContainer>
            <ContactImg src={MapImg} alt="Obrázek znázorňující lokaci" />
            <LocationText>RPK TECHNIK s.r.o Všeradice 96, 267 26</LocationText>
          </ContactContainer>
          <ContactContainer>
            <ContactImg src={EmailImg} alt="Obrázek znázorňující poštovní obálku" />
            <ContactLink href="mailto: servis@rpktechnik.cz">servis@rpktechnik.cz</ContactLink>
          </ContactContainer>
        </ContactRow>
      </FooterContainer>
    </>
  );
}

export default Footer;
